export default __webpack_public_path__ + "static/media/storageUnit1-afterD-2048w.c69cf71b.png";